import { Stack } from '@mui/material';
import { ReleaseChip } from '#/components/Chips';
import ChatAssistantMenu from './chat-assistant-menu';
import ChatTextField from './chat-box-textfield';
import ChatContext from './chat-context';
import ChatSendButton from './chat-send-button';
import type { ChatContextItem } from './types';
import type { UseChatResult } from './use-chat';

export interface ChatBoxProps {
  input: string;
  status: UseChatResult['status'];
  context: ChatContextItem[];
  onContextChange?: (context: ChatContextItem[]) => void;
  onInputChange: UseChatResult['handleInputChange'];
  onSubmit: UseChatResult['handleSubmit'];
}

function ChatBox({
  input,
  context,
  onInputChange,
  onSubmit,
  onContextChange,
  status,
}: ChatBoxProps) {
  return (
    <div className='bg-background-paper p-4 rounded-lg'>
      <form
        noValidate
        autoComplete='off'
        onSubmit={(e) => {
          e.preventDefault();
          if (status === 'streaming' || status === 'submitted') {
            return;
          }
          onSubmit();
        }}
      >
        <Stack direction='row' spacing={1} alignItems='center' className='mb-2'>
          <ChatContext
            context={context}
            disabled={status === 'streaming' || status === 'submitted'}
            onContextChange={onContextChange}
          />
          <div className='flex-1' />
          <ReleaseChip stage='alpha' />
        </Stack>
        <ChatTextField
          disabled={status === 'streaming' || status === 'submitted'}
          value={input}
          onChange={onInputChange}
          onSubmit={onSubmit}
        />
        <Stack direction='row' spacing={1} className='mt-2'>
          <ChatAssistantMenu
            disabled={status === 'streaming' || status === 'submitted'}
          />
          <div className='flex-1' />
          <ChatSendButton
            onClick={onSubmit}
            disabled={!input}
            loading={status === 'streaming' || status === 'submitted'}
          />
        </Stack>
      </form>
    </div>
  );
}

export default ChatBox;
